// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__xUDlX","modalForm":"UpgradeEpcsModal_modalForm__1QIOj","modalFooter":"UpgradeEpcsModal_modalFooter__1r2Rl"};